module.exports = __webpack_public_path__ + "static/media/evaluation.0927225e.png";